// ©2024 Austin App House. All rights reserved.

let handlers = {
  onApply: null,
  onReset: null,
};

export const registerFiltersHandlers = ({ onApply, onReset }) => {
  handlers.onApply = onApply;
  handlers.onReset = onReset;
};

export const emitApplyFilters = (payload) => {
  if (typeof handlers.onApply === 'function') {
    handlers.onApply(payload);
  }
};

export const emitResetFilters = () => {
  if (typeof handlers.onReset === 'function') {
    handlers.onReset();
  }
};


